import * as React from 'react'

import { inject, observer } from 'mobx-react'

import { Resource } from '~/client/src/desktop/components/Resource'
import {
  IResourceControlsConfig,
  ResourceControlsView,
} from '~/client/src/desktop/components/ResourceControls'
import DesktopInitialState from '~/client/src/desktop/stores/DesktopInitialState'
import { MaterialResourcesProvider } from '~/client/src/desktop/views/MaterialResources/MaterialResourcesProvider'
import { MATERIAL_CONTROL_KEYS } from '~/client/src/shared/components/ResourceControls/controlKeys'
import { LocalStorageKey } from '~/client/src/shared/enums/LocalStorageKey'
import { useMaterialResourceStore } from '~/client/src/shared/hooks/useMaterialResourceStore'
import Localization from '~/client/src/shared/localization/LocalizationManager'

function MaterialResourcesControls({ state }: { state?: DesktopInitialState }) {
  const projectId = state?.activeProject?.id || ''
  const userId = state?.user?.id || ''
  const { store } = useMaterialResourceStore(projectId || undefined)

  if (!projectId || !userId || !state) {
    return null
  }

  const config: IResourceControlsConfig = {
    ProviderComponent: MaterialResourcesProvider,
    controlCommands: store.controls,
    columnConfigKey: LocalStorageKey.MaterialsControlsColumnConfig,
    editPanel: <Resource.EditPanel defaultExpandedSectionId="controls" />,
    labels: {
      countTotal: Localization.translator.xMaterials,
      confirmDelete: Localization.translator.confirmDeletionOfMaterials,
    },
    ariaLabel: 'Material controls table',
    controls: MATERIAL_CONTROL_KEYS,
  }

  return (
    <ResourceControlsView
      config={config}
      projectId={projectId}
      userId={userId}
      state={state}
    />
  )
}

export default inject('state')(observer(MaterialResourcesControls))
